
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                <i className="ri-star-fill text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                Ad Astra
              </h3>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Fractional CFO and Bookkeeping services helping private practice owners make more money, save more money, and understand their money.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Fractional CFO</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Bookkeeping</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Financial Analysis</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Cash Flow Management</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Industries</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Medical Practices</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Dental Practices</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Chiropractic</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Ophthalmology</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Ad Astra Fractional CFO and Bookkeeping. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
